import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BalooMatchComponent } from '@fi-app/external-platform-integration/baloo/baloo-match/baloo-match.component';
import { MatCardModule } from '@angular/material/card';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { BalooMatchRolesUnitsComponent } from '@fi-app/external-platform-integration/baloo/baloo-match/baloo-match-roles-units/baloo-match-roles-units.component';
import { BalooMatchUsersComponent } from './baloo-match-users/baloo-match-users.component';
import { FiMatTabGroupBookmarkLayoutModule } from '@fi-shared/fi-mat-card-bookmark-layout/fi-mat-tab-group-bookmark-layout.module';
import { MatInputModule } from '@angular/material/input';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiBalooMatchGroupCard } from '@fi-app/external-platform-integration/baloo/baloo-match/baloo-match-group-card/baloo-match-group-card.component';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { MatIconModule } from '@angular/material/icon';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiAutocompleteItemsModule } from '@fi-shared/fi-autocomplete-items/fi-autocomplete-items.module';
import { FiEmptyListModule } from '@fi-shared/fi-empty-list/fi-empty-list.module';
import { FiIconTooltipButtonModule } from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.module';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        FiAppTextSharedModule,
        SelectSearchModule,
        MatButtonModule,
        MatTabsModule,
        FiMatTabGroupBookmarkLayoutModule,
        MatInputModule,
        FiLocalSearch2Module,
        FiProfileIconModule,
        MatIconModule,
        InfoIconModule,
        FiAutocompleteItemsModule,
        FiEmptyListModule,
        FiIconTooltipButtonModule,
    ],
    declarations: [BalooMatchComponent, BalooMatchRolesUnitsComponent, BalooMatchUsersComponent, FiBalooMatchGroupCard],
})
export class BalooMatchModule {}
